import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { getStore } from '../../../../common/redux/store-utils';

import ExpiredPanel from './components/Panel';
import AuthScreenLayout from '../../components/AuthScreenLayout';
import { registerState } from '../../../../common/Services/RegistrationService.js';

import { isSupportedBrowser } from '../../common/utils';
import UnsupportedBrowsers from '../../components/UnsupportedBrowsers';

const namespace = 'expiredPanel';
const FORM_ID = 'expiredPasswordForm';

import reducer from './redux/reducer';
import saga from './redux/sagas';

const store = getStore();

const createExpiredScreen = () => {
  const domId = 'expiredPanel';
  if (isSupportedBrowser()) {
    registerState({
      namespace,
      reducers: reducer,
      sagas:    [saga],
    });

    ReactDOM.render(
      <Provider store={store}>
        <AuthScreenLayout>
          <ExpiredPanel />
        </AuthScreenLayout>
      </Provider>,
      document.getElementById(domId)
    );
  } else {
    ReactDOM.render(<UnsupportedBrowsers />, document.getElementById(domId));
  }
};

window.createExpiredScreen = createExpiredScreen;
export { namespace, FORM_ID };
